import React, { ComponentType, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/App/hooks';
import { getAboutUsThunk } from '@/features/i18n/i18nSlice';
import { selectLocale } from '@/features/i18n/selectLocale';
import { selectResources } from '@/features/i18n/selectResources';

export interface WithAboutUsTextProps {
  text: string;
}

export const withAboutUsText = <T extends object>(WrappedComponent: ComponentType<T & WithAboutUsTextProps>) => {
  const HOC = (props: T) => {
    const dispatch = useAppDispatch();
    const locale = useAppSelector(selectLocale);
    const resources = useAppSelector(selectResources);
    const { aboutUs } = resources;

    useEffect(() => {
      if (!aboutUs.initialized && locale) {
        dispatch(getAboutUsThunk(locale));
      }
    }, [dispatch, aboutUs, locale]);

    if (!aboutUs.initialized || !locale) {
      return null;
    }

    return <WrappedComponent text={aboutUs.text} {...props} />;
  };
  HOC.displayName = `withAboutUsText(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return HOC;
};
